import { ISite } from "../interface/Sites";

export const siteFormDataModal : ISite = {
    siteID: 0,
    siteNumber: 0,
    siteName: "",
    permit: "",
    issued: null,
    expires: null,
    address1: "",
    address2: "",
    address3: "",
    principal: "",
    schoolPhone: "",
    sFax: "",
    parentEmail: null,
    gradeLevels: "",
    startTime: "",
    stopTime: "",
    started: null,
    closed: null,
    startDate: null,
    waiverExp: null,
    preKindergarten: false,
    universalPreKindergarten: false,
    autoRenew: false,
    originalContract: null,
    districtFee: "",
    closings: "",
    type: 0,
    class: "",
    when: "",
    capacity: 0,
    siteCapacity: 0,
    phone: "",
    phoneType: "",
    timeAvailable: "",
    roomNumber: "",
    scopeEmail: "",
    scopePassword: "",
    scopeFax: "",
    nurseVisit: null,
    secondNurseVisit: null,
    thirdNurseVisit: null,
    midPoint: "",
    additionalLocation: "",
    additionalLocation2: "",
    additionalLocation3: "",
    additionalLocation4: "",
    caP1: 0,
    caP2: 0,
    caP3: 0,
    caP4: 0,
    full: 0,
    daily: 0,
    min: 0,
    ampm: 0,
    policePhone: "",
    // policeName: "",
    policeAddress1: "",
    policeAddress2: "",
    policeAddress3: "",
    // fireName: "",
    firePhone: "",
    fireAddress1: "",
    fireAddress2: "",
    fireAddress3: "",
    landlineLocation: "",
    dssRep: "",
    dssPhone: "",
    transport: "",
    transportPhone: "",
    security: "",
    securityPhone: "",
    safePlace: "",
    ossPlace: "",
    ambulancePhone: "",
    lockdown: "",
    emergency: "",
    additionalEmergencyInfo: "",
    notes: "",
    visitId: 0,
    waitListDate: "",
    waitListCount: 0,
    pcDate: "2024-08-21T10:40:35.415Z",
    pcAmount: 0,
    telephoneVolume: "",
    dataVolume: "",
    relocationRoom1: "",
    relocationRoom2: "",
    attendanceNote: "",
    sourceSchools: "",
    responsiblePerson: "",
    twoNames: "",
    hcpSent: null,
    hcpApproved: null,
    enrollment: 0,
    coExp: "",
    epiPen: false,
    inhaler: false,
    benadryl: false,
    hcpReviewed: null,
    ascaP1: 0,
    ascaP2: 0,
    ascaP3: 0,
    ascaP4: 0,
    roomNumber2: "",
    roomNumber3: "",
    roomNumber4: "",
    staffingAssistantName: "",
    staffingAssistantPhone: "",
    staffingAssistantFax: "",
    staffingAssistantEmail: "",
    staffingAssistantOthers: "",
    staffingAssistantExt: "",
    staffingAssistantForms: "",
    foodContactName: "",
    foodContactPhone: "",
    foodContactFax: "",
    foodContactEmail: "",
    foodContactOthers: "",
    foodContactExt: "",
    foodContactForms: "",
    supplyContactName: "",
    supplyContactPhone: "",
    supplyContactFax: "",
    supplyContactEmail: "",
    supplyContactOthers: "",
    supplyContactExt: "",
    supplyContactForms: "",
    pettyCashSpecialEventContactName: "",
    pettyCashSpecialEventContactPhone: "",
    pettyCashSpecialEventContactFax: "",
    pettyCashSpecialEventContactEmail: "",
    pettyCashSpecialEventContactOthers: "",
    pettyCashSpecialEventContactExt: "",
    pettyCashSpecialEventContactForms: "",
    fieldSupervisorName: "",
    fieldSupervisorPhone: "",
    fieldSupervisorFax: "",
    fieldSupervisorEmail: "",
    fieldSupervisorOthers: "",
    fieldSupervisorExt: "",
    fieldSupervisorForms: "",
    fieldTrainerName: "",
    fieldTrainerPhone: "",
    fieldTrainerFax: "",
    fieldTrainerEmail: "",
    fieldTrainerOthers: "",
    fieldTrainerExt: "",
    fieldTrainerForms: "",
    healthCareConsultantName: "",
    healthCareConsultantPhone: "",
    healthCareConsultantFax: "",
    healthCareConsultantEmail: "",
    healthCareConsultantOthers: "",
    healthCareConsultantExt: "",
    healthCareConsultantForms: "",
    registrarName: "",
    registrarPhone: "",
    registrarFax: "",
    registrarEmail: "",
    registrarOthers: "",
    registrarExt: "",
    registrarForms: "",
    accountBillingName: "",
    accountBillingPhone: "",
    accountBillingFax: "",
    accountBillingEmail: "",
    accountBillingOthers: "",
    accountBillingExt: "",
    accountBillingForms: "",
    substitutesName: "",
    substitutesPhone: "",
    substitutesFax: "",
    substitutesEmail: "",
    substitutesOthers: "",
    substitutesExt: "",
    substitutesForms: "",
    suppliesName: "",
    suppliesPhone: "",
    suppliesFax: "",
    suppliesEmail: "",
    suppliesOthers: "",
    suppliesExt: "",
    suppliesForms: "",
    accountAssistantOthers: "",
    priority: 0,
    scopeDSSName: "",
    scopeDSSPhone: "",
    scopeDSSFax: "",
    scopeDSSEmail: "",
    scopeDSSOthers: "",
    scopeDSSExt: "",
    scopeDSSForms: "",
    presentersName: "",
    presentersPhone: "",
    presentersFax: "",
    presentersEmail: "",
    presentersOthers: "",
    presentersExt: "",
    presentersForms: "",
    photoIDsName: "",
    photoIDsPhone: "",
    photoIDsFax: "",
    photoIDsEmail: "",
    photoIDsOthers: "",
    photoIDsExt: "",
    photoIDsForms: "",
    accountAssistantName: "",
    accountAssistantPhone: "",
    accountAssistantFax: "",
    accountAssistantEmail: "",
    county: "",
    evacuation1Location: "",
    evacuation1Address1: "",
    evacuation1Address2: "",
    evacuation1Address3: "",
    evacuation1Phone: "",
    evacuation2Location: "",
    evacuation2Address1: "",
    evacuation2Address2: "",
    evacuation2Address3: "",
    evacuation2Phone: ""
}